<template>
  <div class="page-wrapper about-page contact">
    <div class="about-background"></div>
    <div class="nav-info">
      <NavInfo/>
    </div>
    <main class="about-info" id="topPage">
      <div id="textForm">
        <h1 class="wcrc">Contact</h1>
        <form class="form" @submit.prevent="submitForm" ref="textForm" autocomplete="off">
          <div class="form-group">
            <label for="senderName">Name</label>
            <input type="text" v-model="form.senderName" placeholder="Your name" id="senderName"/>
          </div>
          <div class="form-group">
            <label for="senderAddress">Email</label>
            <input type="email" v-model="form.senderAddress" placeholder="Your email address" id="senderAddress"/>
          </div>
          <div class="form-group">
            <label for="senderAddressConfirm">Confirm Email</label>
            <input type="email" v-model="form.senderAddressConfirm" placeholder="Retype your email address"
                   id="senderAddressConfirm"/>
          </div>
          <div class="form-group">
            <label for="messageContent">Message</label>
            <textarea v-model="form.messageContent" placeholder="Your message" id="messageContent"/>
          </div>
          <!--TODO: Should we use hidden input or captcha?-->
          <div>
            <button>Send</button>
          </div>
        </form>
        <p v-if="error">{{ error }}</p>
        <p v-if="success">{{ success }}</p>
      </div>
    </main>
  </div>
</template>

<script>
import {
  apiService
} from "../common/api.service";
import NavInfo from "../components/NavInfo";

export default {
  name: "Contact",
  components: {
    NavInfo
  },
  data() {
    return {
      form: {
        senderName: null,
        senderAddress: null,
        senderAddressConfirm: null,
        messageContent: null,
      },
      error: null,
      success: null,
      contactEndpoint: 'https://api.greenhamwomen.digital/contact/message/',
    }
  },
  methods: {
    submitForm() {
      if (!this.form.senderName) {
        this.error = "Please share your name."
      } else if (this.form.senderAddress !== this.form.senderAddressConfirm) {
        this.error = "Email addresses do not match."
      } else if (!this.form.messageContent || this.form.messageContent.length < 50) {
        this.error = "Your message is too short."
      } else if (this.form.messageContent > 1500) {
        this.error = "Would you mind trimming your message? You can always send another one!"
      } else {
        let endpoint = this.contactEndpoint
        let method = "POST";
        let data = {
          "sender_name": this.form.senderName,
          "sender_address": this.form.senderAddress,
          "message_content": this.form.messageContent
        }
        apiService(endpoint, method, data).then(comment_data => {
          console.log(comment_data)
          this.clearFormData()
          this.success = "Message dispatched successfully, thank you for reaching out!"
        })
      }
    },
    clearFormData() {
      this.form.senderName = ""
      this.form.senderAddress = ""
      this.form.senderAddressConfirm = ""
      this.form.messageContent = ""
    },
  },
  mounted() {
    document.getElementById("topPage").scrollIntoView();
  }
}
</script>

<style scoped>
@media screen and (min-width: 660px) {
  main {
    width: 32em;
  }
}
</style>
